import React, { useState, useContext } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'
import TableFooter from 'shared/tables/table-footer'
import TableLoading from 'shared/tables/table-loading'
import MutedText from 'shared/forms/muted-text'
import UserBadges from 'duties/employees/UserBadges'
import { useDataAccessUsers } from 'api/hooks/use-data-access-users'
import InactiveUsersToggle from 'duties/filters/inactive-users'
import UserContext from 'context/user-context'
import AccessToggle from './AccessToggle'

function EmployeesTab({ dataAccessId }) {
  const { municipality } = useContext(UserContext)
  const defaultParams = {
    page: 1,
    perPage: 25,
    data_access_id: dataAccessId,
    active: true,
    hideNoAccess: true,
    hideInactiveRoles: true
  }
  const [params, setParams] = useState(defaultParams)
  const { data, isSuccess, isLoading } = useDataAccessUsers({
    params: params
  })

  const mapAccessType = (accessType) => {
    switch (accessType) {
      case 'org':
        return municipality.setting?.org_name || 'Org'
      case 'object':
        return municipality.setting?.object_name || 'Object'
      case 'seg_one':
      case 'fund':
        return municipality.setting?.seg_one_name || 'Seg One'
      case 'seg_two':
        return municipality.setting?.seg_two_name || 'Seg Two'
      case 'seg_three':
        return municipality.setting?.seg_three_name || 'Seg Three'
      case 'seg_four':
        return municipality.setting?.seg_four_name || 'Seg Four'
      case 'seg_five':
        return municipality.setting?.seg_five_name || 'Seg Five'
      case 'seg_six':
        return municipality.setting?.seg_six_name || 'Seg Six'
      case 'seg_seven':
        return municipality.setting?.seg_seven_name || 'Seg Seven'
      case 'seg_eight':
        return municipality.setting?.seg_eight_name || 'Seg Eight'
      case 'project':
        return municipality.setting?.project_name || 'Project'
      default:
        return accessType
    }
  }

  return (
    <Row>
      <Col sm={12}>
        <Card className="border">
          <Card.Header className="bg-white">
            <Row>
              <Col sm={'auto'}>
                <div className="text-info mt-1">Users</div>
              </Col>
              <Col sm={'auto'}>
                <div className="d-flex justify-content-start ms-3">
                  <InactiveUsersToggle params={params} setParams={setParams} />
                </div>
              </Col>
              <Col sm={'auto'}>
                <div className="d-flex justify-content-start ms-3">
                  <AccessToggle params={params} setParams={setParams} />
                </div>
              </Col>
              <Col sm={'auto'}>
                <div className="d-flex justify-content-start ms-3">
                  <div className="form-check form-switch mt-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="hideInactiveRoles"
                      checked={params.hideInactiveRoles}
                      onChange={() =>
                        setParams({
                          ...params,
                          hideInactiveRoles: !params.hideInactiveRoles
                        })
                      }
                    />
                    <label
                      className="form-check-label"
                      htmlFor="hideInactiveRoles"
                    >
                      Hide Inactive User Roles
                    </label>
                  </div>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            {/* TODO: Consolidate to a single Users (Employees) Table */}
            <Table responsive size="sm">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Access</th>
                  <th>From Role</th>
                  <th>Program</th>
                  <th>Details</th>
                </tr>
              </thead>

              <tbody>
                {isLoading && <TableLoading columns={4} />}
                {isSuccess &&
                  data.data.map((row) => (
                    <tr key={`user-data-access-${row.id}`}>
                      <td>
                        <a
                          href={`/users/${row.employee_id}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {row?.user?.external_id}
                        </a>
                        <MutedText className="mx-2">
                          {row?.user?.department_name}
                        </MutedText>
                        <UserBadges user={row.user} />
                      </td>
                      <td>
                        <MutedText className="ms-2">
                          {row?.no_access ? 'No Access' : 'Access'}
                        </MutedText>
                      </td>
                      <td>
                        <a
                          href={`/roles/${row?.role_id}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {row?.role?.name}
                        </a>
                      </td>
                      <td>{row?.program_name || row?.program_id}</td>
                      <td>
                        {!row?.end1 ? (
                          <span>{row?.start1}</span>
                        ) : (
                          <MutedText>
                            {mapAccessType(row?.access_type)}: {row?.start1} -{' '}
                            {row?.end1}
                          </MutedText>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            {isSuccess && (
              <TableFooter
                meta={data.meta}
                params={params}
                setParams={setParams}
              />
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default EmployeesTab
